import LocalizedStrings from "react-localization";
import React from "react";
import { sanitizeHtml } from "utils/sanitizeHtml";

export const renderString = (formattedString: any) => {
	if (!formattedString) return null;

	return <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(String(formattedString)) }} />;
};

export default new LocalizedStrings({
	/* cSpell:enable */
	/* cSpell.language:pt,pt_PT */
	pt: {
		// Generic
		generic: {
			profile: "Perfil",
			numeration: "{0}a",
			save: "Guardar",
			confirm: "Confirmar",
			supportPlan: "Plano de Apoio Psicológico Team 24",
			supportPlanPsyc: "Plataforma do Psicólogo Team 24",
			supportPlanHr: "Portal de Gestão RH",
			permit: "Permitir",
			noThankYou: "Não, obrigado",
			receiveNotificationsDescription: "Gostaríamos de lhe mostrar notificações relativas às suas consultas.",
			yes: "Sim",
			no: "Não",
			uploadFile: "Clique ou arraste o ficheiro para aqui",
			search: "Pesquisar...",
			close: "Fechar",
			loading: "A carregar...",
			accept: "Aceitar",
			ignore: "Ignorar",
			delete: "Apagar",
			areYouSure: "Tem a certeza que deseja apagar?",
			request: "Pedir"
		},

		password_requirements: {
			minLength: "Pelo menos 8 caracteres",
			upperCase: "Pelo menos uma letra maiúscula (A-Z)",
			lowerCase: "Pelo menos uma letra minúscula (a-z)",
			number: "Pelo menos um número (0-9)",
			specialChar: `Pelo menos um caractere especial (!@#$%^&*(),.?":{}|<>)`
		},

		fields: {
			startDate: "Data Inicial",
			endDate: "Data Final",
			name: "Nome",
			update: "Alterar",
			actions: "Ações",
			error: "Erro",
			about: "Sobre",
			edit: "Editar",
			closed: "Fechado"
		},

		sidebar: {
			home: "Início",
			appointments: "Videoconsultas",
			chat: "Chat",
			profile: "Perfil",
			hello: "Olá",
			terms: "Termos e Condições",
			conditions: "Ver Condições",
			privacy: "Política de Privacidade",
			dashboard: "Visão Geral",
			coworkers: "Colaboradores",
			contactUs: "Contacte-nos",
			patients: "Pacientes",
			terminate: "Terminar Sessão"
		},

		language: {
			header: "Idioma",
			defaultLanguage: "Idioma Padrão",
			languageNotActive: "Guarde as atualizações antes de proceder à alteração do idioma padrão.",
			portuguese: "Português",
			english: "Inglês",
			german: "Alemão",
			french: "Francês",
			spanish: "Espanhol"
		},

		// Screens
		authentication: {
			welcome: "Bem-vindo",
			header: "Autenticação",
			register: "Registo",
			login: "Login",
			logout: "Logout",
			signIn: "Entrar",
			signOut: "Sair",
			confirmAccount: "Confirmar Conta",
			name: "Nome",
			namePlaceholder: "O seu nome",
			email: "E-mail",
			emailPlaceholder: "O seu e-mail",
			password: "Password",
			passwordPlaceholder: "A sua password",
			newPassword: "Nova password",
			newPasswordPlaceholder: "Inserir nova password",
			confirmPassword: "Confirmar Password",
			confirmPasswordPlaceholder: "Repetir a password",
			forgotPassword: "Esqueceu-se da password?",
			loginFooter: "Não tem conta?",
			registerFooter: "Já tem conta? Autentique-se aqui.",
			resendCode1: "Não recebeu o seu código de confirmação? ",
			resendCode2: "Reenviar código de ativação",
			sendEmail: "Enviar e-mail",
			recoverPassword: "Recuperar password",
			changePassword: "Mudar password",
			changeEmail: "Mudar e-mail",
			newEmail: "Novo e-mail",
			newEmailConfirm: "Confirmar novo e-mail",
			repeatEmail: "Repetir e-mail",
			currentEmail: "E-mail Atual",
			currentPassword: "Password Atual",
			emailSent: "E-mail enviado com sucesso",
			repeatPassword: "Repetir Password",
			rememberedPassword: "Lembrou-se da password?",
			adminPassword: "Password do Administrador",
			notLoggedIn: "Necessita de estar autenticado para ter acesso a esta página",
			noMatchPassword: "As passwords não coincidem",
			acceptSubtitle: "Por favor insira uma password para confirmar a sua conta.",
			goBackToLogin: "Ir para o ecrã de início de sessão",
			newAccount: "Nova Conta",
			registeredSuccessfully:
				"Conta registada com sucesso. Por favor, verifique a sua caixa de e-mail para confirmar a conta.",
			passwordChanged: "Password alterada com sucesso.",
			accountConfirmed: "Conta confirmada com sucesso.",
			typeCredentials: "Insira o seu e-mail e password para entrar",
			loginConfirmAccount: "Ainda não tem conta?",
			loginConfirmAccount2: "Confirme a sua conta",
			insertEmail: "Insira o seu e-mail para confirmar a sua conta",
			definePassword: "Definir Password",
			definePassword2: "Defina a sua password de acesso",
			acceptTerms: "Ao confirmar a conta, aceita os",
			acceptTerms2: "e a",
			acceptEmailContent: "Aceito receber conteúdos por e-mail",
			acceptance: "Necessita aceitar os termos e condições para poder confirmar a sua conta.",
			recover: "Recuperar",
			insertEmailPassword: "Insira o seu e-mail para recuperar a sua password",
			actualPassword: "Password Atual",
			passwordinfo:
				"A password deve ter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial.",
			passwordExpired: "A sua password expirou. Por favor, defina uma nova password para continuar.",
			changeExpiredPassword: "Alterar Password Expirada",
			passwordChangedSuccess: "Password alterada com sucesso. Por favor, faça login novamente."
		},

		notFound: {
			header: "Página Inexistente"
		},

		errors: {
			invalidArgs: "Argumentos inválidos ou em falta",
			invalidFields: "Campos inválidos ou em falta",
			emailIsInvalid: "O formato de e-mail inserido não é válido",
			fillEmail: "Insira um e-mail por favor",
			fillPassword: "Insira uma password por favor",
			pleaseFillFormCorrectly: "Por favor, preencha o formulário corretamente",
			fillField: "Este campo é de preenchimento obrigatório",
			notSupportedFile: "Tipo de ficheiro não suportado",
			nameIsEmpty: "O campo nome é de preenchimento obrigatório",
			passwordsDontMatch: "Os campos 'Nova password' e 'Confirmar password' não coincidem",
			emailIsEmpty: "O campo e-mail é de preenchimento obrigatório",
			fileTooBigorInvalid: "O tamanho da imagem é superior a 8MB ou tem um formato inválido",
			invalidFormat: "Formato Inválido"
		},

		profile: {
			header: "Perfil",
			generalInfo: "Informação Geral",
			phone: "Telefone",
			removePicture: "Remover Imagem",
			saved: "Perfil guardado com sucesso.",
			addPhoto: "Adicionar Foto",
			editPhoto: "Editar Foto",
			myAccount: "A minha conta",
			changeEmail: "Alterar E-mail",
			changePassword: "Alterar Password",
			actualEmail: "E-mail Atual",
			newEmail: "Novo E-mail",
			newPassword: "Nova Password",
			emailChange: "O e-mail foi alterado com sucesso.",
			emailSent: "Foi enviado um e-mail para confirmação da alteração de e-mail.",
			emailEmpty: "O campo novo e-mail está vazio.",
			passwordEmpty: "É necessário digitar a sua password para alterar o seu e-mail.",
			emailSameAsCurrent: "O novo e-mail tem de ser diferente do e-mail atual.",
			emailDuplicate: "Este e-mail já está associado a outra conta.",
			emailCodeInvalid: "O link de confirmação é inválido ou expirou. Por favor, solicite uma nova alteração de e-mail.",
			pendingEmailChange: "Alteração pendente para {0}",
			pendingEmailChangeNote:
				"Confirme a alteração através do link que enviámos para esse e-mail. Até lá, o seu e-mail atual mantém-se ativo.",
			review: "Avaliação",
			reviews: "Avaliações",
			psychologist: "Psicólogo",
			noAbout: "Ainda não tem qualquer informação sobre si.",
			competencies: "Competências",
			noSkills: "Ainda não definiu as suas competências.",
			noReviews: "Ainda não tem avaliações.",
			noLanguage: "Sem idioma preferencial definido",
			noLanguages: "Ainda não definiu os seus idiomas.",
			contactSent: "A sua mensagem foi enviada com sucesso.",
			receiveEmailNotifications: "Receber e-mails",
			receiveNotifications: "Receber notificações",
			language: "Idioma Preferencial",
			languages: "Idiomas Preferenciais",
			languageNote:
				"O idioma será somente utilizado para agendamento de consultas, de modo a encontrarmos psicólogos adequados ao seu idioma."
		},

		home: {
			nextAppointment: "Próxima Consulta",
			nextAppointments: "Próximas Consultas",
			noAppointments: "Ainda não tem consultas agendadas",
			noAppointmentsReport: "Não tem relatórios pendentes",
			scheduledAppointments: "Consultas Futuras",
			needChat: "Precisa de falar com um dos nossos psicólogos?",
			startChat: "Iniciar Chat",
			scheduleAppointment: "Agende uma Videoconsulta de Psicologia",
			scheduleVideoAppointment: "Agendar Videoconsulta",
			psychologicalAppointment: "Consulta de Psicologia",
			psychologicalSupportRequest: "Pedido de <b>Apoio Psicológico</b>",
			eapSupportRequest: "Pedido de <b>Apoio EAP</b>",
			pendingChats: "Chats Pendentes",
			dailyAppointments: "Consultas do Dia",
			noChats: "Nenhum chat pendente.",
			noDailyAppointments: "Sem consultas para o dia selecionado.",
			pendingCalls: "Chamadas Pendentes",
			noCalls: "Não existem chamadas pendentes.",
			videoCalls: "Consulta Remotas",
			callsNotAnswered: "Chamadas não atendidas",
			noCallsNotAnswered: "Não existem chamadas não atentidas.",
			cantAcceptCall: "Não é possível aceitar uma chamada de áudio estando numa consulta por vídeo ou áudio.",
			noPatientOnCall: "O paciente não se encontra na chamada.",
			newCall: "Uma nova chamada de",
			newCall2: "está pendente de ser atendida.",
			newChat: "Um novo chat de",
			newChat2: "está pendente de ser aceite.",
			treatmentRating: "Classificação do Tratamento",
			questionsNotAnswered:
				"Para enviar a classificação, todas as perguntas devem ser respondidas exceto as notas adicionais.",
			reviewSent: "Classificação enviada com sucesso.",
			skip: "Saltar",
			typeNote: "Adicione uma nota...",
			question1: "De forma geral, está satisfeito(a) com o serviço prestado?",
			question2: "Em que medida gostou do(a) psicólogo(a) que o(a) atendeu?",
			question3: "O(a) psicólogo(a) foi pontual no seu atendimento?",
			question4: "Sente-se melhor depois da intervenção psicológica realizada?",
			question5: "No seu entender, o número de consultas foi adequado?",
			question6: "Em caso de necessidade, voltaria a utilizar o serviço?",
			question7: "Quanto recomendaria este serviço a um colega?",
			question8: "Considera que esta intervenção ajudou a que se sentisse mais motivado?",
			question9: "Considera importante manter o serviço de apoio psicológico na sua organização?",
			notes: "Caso queira deixar alguma sugestão, por favor, escreva abaixo",
			reviewHelp:
				'De {0} a {1}, em que {2} é "{3}" e {4} corresponde a "{5}", por favor, classifique as seguintes afirmações relativas às videoconsultas de Psicologia realizadas com os psicólogos da TEAM 24.',
			notReally: "muito pouco",
			little: "pouco",
			few: "moderadamente",
			many: "muito",
			alot: "extremamente"
		},

		events: {
			live: "A decorrer",
			startsIn: "Começa em",
			daysLeft: "faltam {n} dias",
			dayLeft: "falta 1 dia",
			enter: "Entrar",
			showProgram: "Ver programa",
			hideProgram: "Ocultar programa",
			today: "Hoje",
			tomorrow: "Amanhã"
		},

		appointments: {
            date: "Data",
            hour: "Hora",
			header: "Consultas",
			single: "Consulta",
			history: "Histórico",
			cancel: "Cancelar",
			confirm: "Confirmar",
			reschedule: "Reagendar",
			schedule: "Agendar",
			noAppointments: "Ainda não tem consultas agendadas",
			noAppointmentsReport: "Não tem relatórios pendentes",
			selectDate: "Selecione o dia",
			selectMonth: "Selecione o mês",
			availableSlots: "Horários disponíveis",
			cancelAppointment: "Tem a certeza que quer cancelar a marcação?",
			replyMessage: "Escreva algo aqui...",
			noSlots: "Não existem horários disponíveis para o dia selecionado",
			type: "Consulta de Psicologia",
			noHistory: "Não existem consultas realizadas no período selecionado.",
			created: "A consulta foi marcada com sucesso.",
			rescheduled: "A consulta foi remarcada com sucesso.",
			cancelled: "A consulta foi cancelada com sucesso.",
			checkPatient: "Ver Paciente",
			pendingReport: "Consultas sem Relatório",
			report: "Relatório Clínico",
			noMoreAppointments: "Não há consultas futuras marcadas",
			nextConsultations: "Consultas Seguintes",
			noConsultations: "Não existem mais consultas marcadas.",
			editAppointment: "Editar Consulta",
			edited: "Consulta editada com sucesso.",
			client: "Cliente",
			duration: "Duração",
			lunchBreak: "Pausa para Almoço",
			createReport: "Criar Relatório Clinico",
			startCall: "Iníciar Videochamada",
			selectPsychologist: "Selecione um psicólogo",
			scheduleOptions: "Deseja Marcar",
            scheduleType: "Tipo de Marcação",
            optionOther: "Outro",
            optionConsultation: "Consulta",
            selectPatient: "Selecionar um Paciente",
            motive: "Motivo",
			availabilityLegend: "Disponibilidade"
		},

		chat: {
			header: "Chat",
			startChat: "Iniciar Chat",
			confirmStartChat: "Tem a certeza que deseja iniciar chat",
			endChat: "Deseja encerrar o chat?",
			howDidItGo: "Como avalia o apoio prestado pelo psicólogo?",
			noMatchingCriteria: "Não existem pacientes de acordo com a pesquisa efetuada.",
			empty: "Ainda não tem pacientes associados",
			noChats: "Ainda não existem chats disponíveis.",
			closedChat: "Este chat está fechado e não pode ser mais respondido.",
			closedChatFormat1: "Este chat está fechado. Carregue",
			outOfOpeningHours: "Obrigada por contactar a TEAM 24, brevemente um psicólogo irá atender o seu chat.",
			here: "aqui",
			closedChatFormat2: "para abrir novamente.",
			selectRating: "Por favor classifique a chamada antes de prosseguir.",
			sentReview: "Obrigado(a) por submeter a sua classificação.",
			chatOpen: "Já existe um chat pendente ou aberto.",
			selectChat: "Por favor selecione um chat ou inicie um novo",
			selectChatPsych: "Por favor selecione um chat",
			confirmDeleteMessage: "Tem a certeza que deseja eliminar a mensagem?"
		},

		coworkers: {
			number: "N.º Colaborador (0-9)",
			status: "Estado",
			add: "Adicionar Colaborador",
			edit: "Editar Colaborador",
			upload: "Importar Colaboradores",
			uploadDisable: "Desativar Colaboradores",
			download: "Download Template",
			import: "Importar",
			imported: "Os colaboradores foram importados com sucesso.",
			importedWithErrors:
				"Colaboradores importados com sucesso. Alguns colaboradores não foram importados (ver lista de erros).",
			importedErrors: "Colaboradores não Importados (Erros)",
			roleUser: "Colaborador",
			roleHr: "Recursos Humanos",
			added: "O Colaborador foi adicionado com sucesso.",
			edited: "O Colaborador foi editado com sucesso.",
			deleted: "O Colaborador foi removido com sucesso.",
			role: "Cargo",
			business: "Empresa",
			group: "Grupo",
			resendInvite: "Reenviar Confirmação Conta",
			areYouSure: "Deseja reenviar o email de confirmação de conta para todos os colaboradores pendentes?",
			innactiveUsers: "Ver Inativos",
			resendBusinessEmailSuccess: "Os emails de confirmação vão ser enviados nos próximos minutos."
		},

		dashboard: {
			contract: "Contrato",
			sosButton: "Botão de Chamada",
			chatButton: "Botão de Chat",
			usage: "Utilizadores",
			videoAppointments: "Videoconsultas de Psicologia",
			hotline: "Linhas de Apoio Psicológico",
			disturbances: "Problemáticas Identificadas",
			contractDetails: "Detalhe Contrato",
			purchased: "Contratadas",
			consumed: "Marcadas",
			balance: "Balanço",
			scheduled: "Consultas Marcadas",
			finished: "Consultas Realizadas",
			details: "Ver Detalhe",
			clicked: "N.º Vezes Clicado",
			newUsers: "Novos Utilizadores",
			usageApp: "Utilização App",
			noData: "Não existe data registada no período selecionado.",
			calls: "Linha Telefónica de Apoio Psicológico",
			chats: "Chat de Apoio Psicológico",
			exportPdf: "Exportar relatório em PDF",
			exportRateLimited: "Já foram gerados demasiados relatórios; tente novamente dentro de alguns minutos."
		},

		contactUs: {
			haveQuestions: "Tem dúvidas?",
			sendUsMessage:
				"Pode deixar o seu pedido/dúvida, que a nossa equipa irá dar resposta o mais brevemente possível.",
			subject: "Assunto",
			description: "Descrição",
			send: "Enviar"
		},

		eap: {
			legal: 'Apoio <br/><span class="eap-highlight"><b>Jurídico</b></span>',
			tax: 'Apoio <br/><span class="eap-highlight"><b>Fiscal</b></span>',
			finantial: 'Apoio <br/><span class="eap-highlight"><b>Financeiro</b></span>',
			social: 'Apoio <br/><span class="eap-highlight"><b>Social</b></span>',
			nutritional: 'Apoio <br/><span class="eap-highlight"><b>Nutricional</b></span>',
			healthInsurance: 'Seguro de <br/><span class="eap-highlight"><b>Saúde</b></span>',
			text: "Envie-nos o seu pedido e iremos responder com a maior brevidade possível!",
			requests: "Pedidos",
			nif: "Coloque o seu NIF aqui..."
		},

		patients: {
			patient: "Paciente",
			clinicalRecord: "Ficha Clínica",
			otherName: "Nome pelo qual quer ser tratado",
			birthdate: "Data de nascimento",
			treatments: "Tratamentos",
			treatment: "Tratamento",
			diagnostics: "Problemáticas Identificadas",
			clinicalDischarge: "Alta Clínica",
			takeMeds: "Toma medicação?",
			meds: "Medicação",
			objective: "Objetivos do Tratamento",
			details: "Ver detalhes",
			noTreatments: "Não existem tratamentos registados para este paciente.",
			saved: "O paciente foi editado com sucesso."
		},

		reports: {
			header: "Relatório Clínico",
			anamnese: "Anamnese Clínica",
			report: "Registo Clínico",
			notes: "Notas Pessoais",
			intervention: "Intervenção Clínica",
			objectivesNextAppointment: "Objetivos para a Próxima Consulta",
			date: "Data e Hora da Consulta",
			schedule: "Agendar Próxima Consulta",
			save: "Gravar Relatório Clínico",
			saved: "Relatório clínico guardado com sucesso.",
			reportClosed: "O relatório desta consulta já foi concluído.",
			invalidDiagnostics: "O campo diagnóstico é de preenchimento obrigatório.",
			invalidGoals: "O campo objetivos do tratamento é de preenchimento obrigatório",
			invalidAnamnesis: "O campo anamnese clínica é de preenchimento obrigatório"
		},

		placeholders: {
			name: "o seu nome",
			email: "o_seu@email.com",
			phoneNumber: "+351265000000 (0-9)",
			language: "Selecione um idioma",
			role: "Selecione um cargo",
			currentPassword: "password atual",
			newPassword: "nova password",
			confirmPassword: "confirme nova password",
			newEmail: "novo@email.com",
			page: "página",
			titlePage: "Título da Página",
			link: "https://www.google.com/",
			profilePic: "Imagem de Perfil",
			password: "a sua password",
			description: "Escreva a sua questão...",
			selectSkills: "Selecione as suas competências",
			selectLanguages: "Selecione os seus idiomas",
			patients: "Procure paciente..."
		},

		serverErrors: {
			title: "Erro de Servidor",
			subTitle: "Não é você, somos nós!",
			refresh: "Voltar à Página Anterior",
			backToHome: "Ir para o Início",
			accountNotConfirmed: "Conta não confirmada.",
			notFound: "Conta não existente.",
			invalidCredentials: "Conta não existe ou credenciais inválidas.",
			tooManyRequests: "Demasiadas tentativas. Por favor, tente novamente mais tarde.",
			requestNotPossible: "Não foi possível contactar com o servidor. Por favor, tente mais tarde."
		},

		footer: {
			downloadOn: "Download on the",
			appStore: "App Store",
			getIt: "Get it on",
			googlePlay: "Google Play"
		},

		ranges: {
			today: "Hoje",
			thisMonth: "Este mês",
			lastMonth: "Mês anterior",
			thisYear: "Este ano",
			lastYear: "Ano anterior"
		},

		video: {
			fullscreen: "Ecrã Inteiro",
			exitFullscreen: "Sair de Ecrã Inteiro",
			minimize: "Minimizar Janela",
			maximize: "Restaurar Janela",
			mute: "Desativar Microfone",
			unmute: "Ativar Microfone",
			disableVideo: "Desativar Vídeo",
			enableVideo: "Ativar Vídeo",
			disconnect: "Terminar Chamada"
		},

		dnd: {
			title: "Não incomodar",
			oneHour: "1 hora",
			twoHours: "2 horas",
			untilEndOfDay: "Até ao fim do dia",
			turnOff: "Desligar",
			activeUntil: "Silenciado até {0}",
			tooltip: "As chamadas SOS e os pedidos de chat continuam a aparecer no Início, apenas sem som nem alerta.",
			missedSummary: "Recebeste {0} chamadas SOS e {1} pedidos de chat enquanto estavas em Não incomodar.",
			goToHome: "Ir para o Início",
			tooltipInactive: "Silenciar o toque das chamadas SOS e dos chats durante um período",
			chooseDuration: "Silenciar notificações durante:",
			activatedFeedback: "Não incomodar ativo até {0}. As chamadas SOS e chats continuam a aparecer no Início.",
			deactivatedFeedback: "Não incomodar desligado"
		}
	},

	/* cSpell.language:en */
	en: {
		// Generic
		generic: {
			profile: "Profile",
			numeration: "{0}rd",
			save: "Save",
			confirm: "Confirm",
			supportPlan: "Team 24 Psychological Plan",
			supportPlanPsyc: "Team 24 Psychologist Platform",
			supportPlanHr: "HR Management Portal",
			permit: "Permit",
			noThankYou: "No Thank You",
			receiveNotificationsDescription: "We would like to send you push notifications about your consultations.",
			yes: "Yes",
			no: "No",
			uploadFile: "Click or drag the file into this box",
			search: "Search...",
			close: "Close",
			loading: "Loading...",
			accept: "Accept",
			ignore: "Ignore",
			delete: "Delete",
			areYouSure: "Are you sure you want to delete?",
			request: "Request"
		},

		password_requirements: {
			minLength: "At least 8 characters",
			upperCase: "At least one uppercase letter (A-Z)",
			lowerCase: "At least one lowercase letter (a-z)",
			number: "At least one number (0-9)",
			specialChar: "At least one special character (!@#$%^&*()_+|~=`{}[]:\";'<>?,./)"
		},

		fields: {
			startDate: "Start Date",
			endDate: "End Date",
			name: "Name",
			update: "Update",
			actions: "Actions",
			error: "Error",
			about: "About",
			edit: "Edit",
			closed: "Closed"
		},

		sidebar: {
			home: "Home",
			appointments: "Consultations",
			chat: "Chat",
			profile: "Profile",
			hello: "Hello",
			terms: "Terms and Conditions",
			conditions: "Conditions",
			privacy: "Privacy Policy",
			dashboard: "Dashboard",
			coworkers: "Co-Workers",
			contactUs: "Contact Us",
			patients: "Patients",
			terminate: "Log out"
		},

		language: {
			header: "Language",
			defaultLanguage: "Default Language",
			languageNotActive: "Save the changes before changing the default language.",
			portuguese: "Portuguese",
			english: "English",
			german: "German",
			french: "French",
			spanish: "Spanish"
		},

		// Screens
		authentication: {
			welcome: "Welcome",
			header: "Authentication",
			register: "Register",
			login: "Login",
			logout: "Logout",
			signIn: "Sign in",
			signOut: "Sign out",
			confirmAccount: "Confirm Account",
			name: "Name",
			namePlaceholder: "Your name",
			email: "E-mail",
			emailPlaceholder: "Your e-mail",
			password: "Password",
			passwordPlaceholder: "Your password",
			newPassword: "New password",
			newPasswordPlaceholder: "Enter new password",
			confirmPassword: "Confirm password",
			confirmPasswordPlaceholder: "Repeat your password",
			forgotPassword: "Forgot your password?",
			loginFooter: "New account?",
			registerFooter: "Do you have an account? Login here",
			resendCode1: "Have you not received your confirmation code? ",
			resendCode2: "Resend activation code",
			sendEmail: "Send E-mail",
			recoverPassword: "Recover Password",
			changePassword: "Change Password",
			changeEmail: "Change E-mail",
			newEmail: "New E-mail",
			repeatEmail: "Repeat E-mail",
			newEmailConfirm: "Confirm New E-mail",
			currentEmail: "Current E-mail",
			currentPassword: "Current Password",
			emailSent: "E-mail Sent Successfully",
			repeatPassword: "Repeat Password",
			rememberedPassword: "Did you remember your password?",
			adminPassword: "Admin Password",
			notLoggedIn: "You need to be logged in to access this page",
			noMatchPassword: "Passwords don't match",
			acceptSubtitle: "Please input a password to confirm your account.",
			goBackToLogin: "Go to the login screen",
			newAccount: "New account",
			registeredSuccessfully:
				"Registration completed successfully. Please check your registered e-mail to verify your e-mail.",
			passwordChanged: "Password changed successfully.",
			accountConfirmed: "Account confirmed successfully.",
			typeCredentials: "Type your e-mail and password to enter",
			loginConfirmAccount: "No account yet?",
			loginConfirmAccount2: "Confirm your account",
			insertEmail: "Please type your e-mail to confirm your account",
			definePassword: "Define Password",
			definePassword2: "Define a password for your account",
			acceptTerms: "When confirming your account, you're accepting",
			acceptTerms2: "and",
			acceptEmailContent: "I accept to subscribe to e-mail content",
			acceptance: "You need to accept terms and conditions in order to confirm your account.",
			recover: "Recover",
			insertEmailPassword: "Please type your e-mail to recover your password",
			actualPassword: "Actual Password",
			passwordinfo:
				"Password must have at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character.",
			passwordExpired: "Your password has expired. Please set a new password to continue.",
			changeExpiredPassword: "Change Expired Password",
			passwordChangedSuccess: "Password changed successfully. Please log in again."
		},

		notFound: {
			header: "Not Found"
		},

		errors: {
			invalidArgs: "Invalid or missing arguments",
			invalidFields: "Invalid or missing fields",
			emailIsInvalid: "E-mail format is not valid",
			fillEmail: "Please input your e-mail",
			fillPassword: "Please input your password",
			pleaseFillFormCorrectly: "Please fill the form correctly",
			fillField: "This field is mandatory",
			notSupportedFile: "File type not supported",
			nameIsEmpty: "Please fill name field",
			passwordsDontMatch: "Fields 'New password' and 'Confirm password' don't match",
			emailIsEmpty: "Please fill e-mail field",
			fileTooBigorInvalid: "File size is larger than 8MB or file is corrupt",
			invalidFormat: "Invalid Format"
		},

		profile: {
			header: "Profile",
			generalInfo: "General Information",
			phone: "Phone Number",
			removePicture: "Remove Picture",
			saved: "Profile has been saved sucessfully.",
			addPhoto: "Add Photo",
			editPhoto: "Edit Photo",
			myAccount: "My Account",
			changeEmail: "Change E-mail",
			changePassword: "Change Password",
			actualEmail: "Actual E-mail",
			newEmail: "New E-mail",
			newPassword: "New Password",
			emailChange: "E-mail has been changed successfully.",
			emailSent: "An e-mail was sent to confirm e-mail changes.",
			emailEmpty: "New e-mail field is empty.",
			passwordEmpty: "You need to type your password to change your e-mail.",
			emailSameAsCurrent: "The new e-mail must be different from your current e-mail.",
			emailDuplicate: "This e-mail is already associated with another account.",
			emailCodeInvalid: "The confirmation link is invalid or has expired. Please request a new e-mail change.",
			pendingEmailChange: "Pending change to {0}",
			pendingEmailChangeNote:
				"Confirm the change through the link we sent to that e-mail. Until then, your current e-mail remains active.",
			review: "Review",
			reviews: "Reviews",
			psychologist: "Psychologist",
			noAbout: "You do not have any information about you yet.",
			competencies: "Compentencies",
			noSkills: "You haven't set your competencies yet.",
			noReviews: "You have no reviews yet.",
			noLanguage: "Without preferencial language defined",
			noLanguages: "You haven't selected your languages yet.",
			contactSent: "Request has been sent successfully.",
			receiveEmailNotifications: "Receive E-mails",
			receiveNotifications: "Receive Notifications",
			language: "Language",
			languages: "Languages",
			languageNote:
				"The language will only be used to schedule appointments, so that we can find psychologists suitable for your language."
		},

		home: {
			nextAppointment: "Next Consultation",
			nextAppointments: "Next Consultations",
			noAppointments: "You have no scheduled consultations",
			scheduledAppointments: "Scheduled Consultations",
			needChat: "Do you need to talk to one of our psychologists?",
			startChat: "Start Chat",
			scheduleAppointment: "Schedule a consultation",
			scheduleVideoAppointment: "Schedule video consultation",
			psychologicalAppointment: "Psychology Consultation",
			psychologicalSupportRequest: "<b>Psychological Support</b> Request",
			eapSupportRequest: "<b>EAP Support</b> Request",
			pendingChats: "Pending Chats",
			dailyAppointments: "Daily Consultations",
			noChats: "No chat are pending.",
			noDailyAppointments: "No daily consultations for the selected date.",
			pendingCalls: "Pending Calls",
			noCalls: "There are no pending calls to be answered.",
			callsNotAnswered: "Calls not Answered",
			noCallsNotAnswered: "There are no calls not answered.",
			videoCalls: "Video Consultations",
			cantAcceptCall: "You cannot accept a voice call while in a video consultation or voice call.",
			noPatientOnCall: "Patient is not on this call.",
			newCall: "New call from",
			newCall2: "is pending.",
			newChat: "New chat from",
			newChat2: "is pending.",
			treatmentRating: "Treatment Rating",
			questionsNotAnswered: "To send a review, all questions must be answered except aditional notes.",
			reviewSent: "Review has been sent successfully.",
			skip: "Skip",
			typeNote: "Type a note...",
			question1: "In general, are you satisfied with the service provided?",
			question2: "Did you like the psychologist who accompanied you?",
			question3: "Was the psychologist punctual?",
			question4: "Do you feel better after the psychological intervention performed?",
			question5: "In your opinion, was the number of consultations adequate?",
			question6: "If necessary, would you use the service again?",
			question7: "How much would you recommend this service to a colleague?",
			question8: "Do you consider that this intervention helped you to feel more motivated?",
			question9: "Do you consider it important to maintain psychological support service in your organization?",
			notes: "If you would like to leave any suggestions, please write below",
			reviewHelp:
				'From {0} to {1}, in wich {2} is "{3}" and {4} corresponds to "{5}", please, classify the following statements related to psychology video consultations performed with psychologists of TEAM 24.',
			notReally: "very little",
			little: "little",
			few: "moderadamente",
			many: "very much",
			alot: "extremely"
		},

		events: {
			live: "Live now",
			startsIn: "Starts in",
			daysLeft: "{n} days to go",
			dayLeft: "1 day to go",
			enter: "Join",
			showProgram: "See programme",
			hideProgram: "Hide programme",
			today: "Today",
			tomorrow: "Tomorrow"
		},

		appointments: {
            date: "Data",
            hour: "Hour",
			header: "Consultations",
			single: "Consultation",
			history: "History",
			cancel: "Cancel",
			confirm: "Confirm",
			reschedule: "Reschedule",
			schedule: "Schedule Consultation",
			noAppointments: "You have no scheduled consultations",
			selectDate: "Select a day",
			selectMonth: "Select a month",
			availableSlots: "Available hours",
			cancelAppointment: "Are you sure you want to cancel this consultation?",
			replyMessage: "Type something here...",
			noSlots: "There are no available slots for the selected date",
			type: "Psychological Consultation",
			noHistory: "There are no previous consultations for the selected period.",
			created: "Consultation has been created successfully.",
			rescheduled: "Consultation has been rescheduled successfully.",
			cancelled: "Consultation has been cancelled successfully.",
			checkPatient: "Check Patient",
			pendingReport: "Consultations Pending Report",
			report: "Clinical Report",
			noMoreAppointments: "There are no scheduled consultations",
			nextConsultations: "Next Consultations",
			noConsultations: "There are no more consultations.",
			editAppointment: "Edit Consultation",
			edited: "Consultation has been edited sucessfully.",
			client: "Client",
			duration: "Duration",
			lunchBreak: "Lunch Break",
			createReport: "Create Clinical Report",
			startCall: "Start Video call",
			selectPsychologist: "Select a psychologist",
			scheduleOptions: "Schedule Options",
            scheduleType: "Schedule Type",
            optionOther: "Other",
            optionConsultation: "Consultation",
            selectPatient: "Select Patient",
            motive: "Motive",
			availabilityLegend: "Availability"
		},

		chat: {
			header: "Chat",
			startChat: "Start Chat",
			confirmStartChat: "Are you sure that you want to start a chat",
			endChat: "Do you wish to close chat?",
			howDidItGo: "How do you rate your chat with the psychologist?",
			noMatchingCriteria: "There are no patient matching your search criteria.",
			empty: "You have no patients.",
			noChats: "There are no chats available.",
			closedChat: "This chat is closed and can no longer be answered.",
			closedChatFormat1: "This chat is closed. Click",
			outOfOpeningHours: "Thank you for contacting TEAM 24, a psychologist will answer your chat soon.",
			here: "here",
			closedChatFormat2: "to re-open.",
			selectRating: "Please select a rating before confirming.",
			sentReview: "Thank you for submitting your rating.",
			chatOpen: "There is an open/pending chat already.",
			selectChat: "Please select a chat or start a new one",
			selectChatPsych: "Please select a chat",
			confirmDeleteMessage: "Are you sure you want to delete the message?"
		},

		coworkers: {
			number: "Employee Number (0-9)",
			status: "Status",
			add: "Add Employee",
			edit: "Edit Employee",
			upload: "Upload Employees",
			uploadDisable: "Disable Employees",
			download: "Download Template",
			import: "Import",
			imported: "All employees have been imported successfully.",
			importedWithErrors:
				"Employees have been imported successfully. Some employees weren't uploaded (check error list).",
			importedErrors: "Unimported Employees (Errors)",
			roleUser: "Collaborator",
			roleHr: "Human Resources",
			added: "Employee has been added successfully.",
			edited: "Employee has been edited successfully.",
			deleted: "Employee has been deleted successfully.",
			role: "Role",
			business: "Business",
			group: "Group",
			resendInvite: "Resend Account Confirmation",
			areYouSure: "Do you want to resend the account confirmation e-mail to all pending employees?",
			innactiveUsers: "View Inactive",
			resendBusinessEmailSuccess: "The emails will be sent in the next few minutes."
		},

		dashboard: {
			contract: "Contract",
			sosButton: "Call Button",
			chatButton: "Chat Button",
			usage: "Users",
			videoAppointments: "Psychologic Video Consultations",
			hotline: "Psychological Support",
			disturbances: "Diagnosed Disorders",
			contractDetails: "Contract Details",
			purchased: "Purchased",
			consumed: "Used",
			balance: "Balance",
			scheduled: "Scheduled Consultations",
			finished: "Consultations Conducted",
			details: "See Detail",
			clicked: "Num. Clicks",
			newUsers: "New Users",
			usageApp: "App Usage",
			noData: "No data for the selected period.",
			calls: "Psychological Support Phone Call",
			chats: "Psychological Support Chat",
			exportPdf: "Export PDF report",
			exportRateLimited: "Too many reports have been generated; please try again in a few minutes."
		},

		contactUs: {
			haveQuestions: "Do you have questions?",
			sendUsMessage: "Send us a message with your questions and we'll answer as soon as possible.",
			subject: "Subject",
			description: "Description",
			send: "Send"
		},

		eap: {
			legal: '<span class="eap-highlight"><b>Legal</b></span><br/>Support',
			tax: '<span class="eap-highlight"><b>Tax</b></span><br/>Support',
			finantial: '<span class="eap-highlight"><b>Financial</b></span><br/>Support',
			social: '<span class="eap-highlight"><b>Social</b></span><br/>Support',
			nutritional: '<span class="eap-highlight"><b>Nutritional</b></span><br/>Support',
			healthInsurance: '<span class="eap-highlight"><b>Health</b></span><br/>Insurance',
			text: "Send us your request and we will answer as soon as possible!",
			requests: "Requests",
			nif: "Insert your TAX number here..."
		},

		patients: {
			patient: "Patient",
			clinicalRecord: "Clinical Record",
			otherName: "Preferred name",
			birthdate: "Birth date",
			treatments: "Treatments",
			treatment: "Treatment",
			diagnostics: "Diagnostic",
			clinicalDischarge: "Clinical Discharge",
			takeMeds: "Does patient take medication?",
			meds: "Medication",
			objective: "Treatment objectives",
			details: "See details",
			noTreatments: "There are no saved treatments for this patient.",
			saved: "Patient has been saved successfully."
		},

		reports: {
			header: "Report",
			anamnese: "Anamnesis",
			report: "Clinical Record",
			intervention: "Clinical Intervention",
			objectivesNextAppointment: "Objectives for the Next Consultation",
			date: "Consultation Date and Time",
			schedule: "Schedule Next Consultation",
			save: "Save Clinical Report",
			saved: "Clinical report has been saved successfully.",
			reportClosed: "Clinical report of this consultations is already filled.",
			invalidDiagnostics: "Diagnostic is a mandatory field.",
			invalidGoals: "Treatment objectives is a mandatory field.",
			invalidAnamnesis: "Anamnesis is a mandatory field."
		},

		placeholders: {
			name: "your name",
			email: "your@email.com",
			phoneNumber: "+351265000000 (0-9)",
			language: "Select a language option",
			role: "Select a role",
			currentPassword: "actual password",
			newPassword: "new password",
			confirmPassword: "confirm new password",
			newEmail: "new@email.com",
			page: "page",
			titlePage: "Page Title",
			link: "https://www.google.com/",
			profilePic: "Profile Picture",
			password: "your password",
			description: "Type your question here...",
			selectSkills: "Select your competencies",
			selectLanguages: "Select your languages",
			patients: "Search patients..."
		},

		serverErrors: {
			title: "Internal Server Error",
			subTitle: "It's not you, it's us!",
			refresh: "Go Back to Previous Page",
			backToHome: "Go to Home",
			accountNotConfirmed: "Account not confirmed.",
			notFound: "Account does not exist.",
			invalidCredentials: "Account does not exist or credentials are invalid.",
			tooManyRequests: "Too many attempts. Please try again later.",
			requestNotPossible: "Connection to the server was not established. Please try again later."
		},

		footer: {
			downloadOn: "Download on the",
			appStore: "App Store",
			getIt: "Get it on",
			googlePlay: "Google Play"
		},

		ranges: {
			today: "Today",
			thisMonth: "This month",
			lastMonth: "Previous month",
			thisYear: "This year",
			lastYear: "Previous year"
		},

		video: {
			fullscreen: "Fullscreen",
			exitFullscreen: "Exit Fullscreen",
			minimize: "Minimize Window",
			maximize: "Restore Window",
			mute: "Mute Microphone",
			unmute: "Unmute Microphone",
			disableVideo: "Disable Video",
			enableVideo: "Enable Video",
			disconnect: "Disconnect"
		},

		dnd: {
			title: "Do not disturb",
			oneHour: "1 hour",
			twoHours: "2 hours",
			untilEndOfDay: "Until the end of the day",
			turnOff: "Turn off",
			activeUntil: "Silenced until {0}",
			tooltip: "SOS calls and chat requests still show up on Home, just without sound or alerts.",
			missedSummary: "You received {0} SOS calls and {1} chat requests while Do not disturb was on.",
			goToHome: "Go to Home",
			tooltipInactive: "Silence the ringing of SOS calls and chats for a period",
			chooseDuration: "Silence notifications for:",
			activatedFeedback: "Do not disturb on until {0}. SOS calls and chats still show up on Home.",
			deactivatedFeedback: "Do not disturb turned off"
		}
	},

	/* cSpell.language:es */
	es: {
		// Generic
		generic: {
			profile: "Perfil",
			numeration: "{0}a",
			save: "Grabar",
			confirm: "Confirmar",
			supportPlan: "Plan de Apoyo Psicológico Team 24",
			supportPlanPsyc: "Portal del Psicólogo Team 24",
			supportPlanHr: "Portal de Gestión RH",
			permit: "Permitir",
			noThankYou: "No, gracias",
			receiveNotificationsDescription: "Nos gustaría enviarte notificaciones sobre tus citas.",
			yes: "Sí",
			no: "No",
			uploadFile: "Haz clic o arrastre el archivo aquí",
			search: "Búsqueda...",
			close: "Cerrar",
			loading: "A cargar...",
			accept: "Aceptar",
			ignore: "Ignorar",
			delete: "Eliminar",
			areYouSure: "¿Estás seguro de que quieres eliminarlo?",
			request: "Solicitar"
		},

		password_requirements: {
			minLength: "Al menos 8 caracteres",
			upperCase: "Al menos una letra mayúscula (A-Z)",
			lowerCase: "Al menos una letra minúscula (a-z)",
			number: "Al menos un número (0-9)",
			specialChar: "Al menos un carácter especial (!@#$%^&*()_+|~=`{}[]:\";'<>?,./)"
		},

		fields: {
			startDate: "Fecha inicial",
			endDate: "Fecha final",
			name: "Nombre",
			update: "Cambiar",
			actions: "Acciones",
			error: "Error",
			about: "Acerca de",
			edit: "Editar",
			closed: "Cerrado"
		},

		sidebar: {
			home: "Inicio",
			appointments: "Videoconsultas",
			chat: "Chat",
			profile: "Perfil",
			hello: "Hola",
			terms: "Términos y Condiciones",
			conditions: "Ver Condiciones",
			privacy: "Política de privacidad",
			dashboard: "Visión general",
			coworkers: "Trabajadores",
			contactUs: "Contáctenos",
			patients: "Pacientes",
			terminate: "Cerrar sesión"
		},

		language: {
			header: "Idioma",
			defaultLanguage: "Idioma predeterminado",
			languageNotActive: "Graba las actualizaciones antes de cambiar el idioma predeterminado.",
			portuguese: "Portugués",
			english: "Inglés",
			german: "Alemán",
			french: "Francés",
			spanish: "Español"
		},

		// Screens
		authentication: {
			welcome: "Bienvenido",
			header: "Autenticación",
			register: "Registro",
			login: "Acceso",
			logout: "Cerrar sesión",
			signIn: "Iniciar sesión",
			signOut: "Salir",
			confirmAccount: "Confirmar cuenta",
			name: "Nombre",
			namePlaceholder: "Tu nombre",
			email: "Correo Electrónico",
			emailPlaceholder: "Tu correo electrónico",
			password: "Contraseña",
			passwordPlaceholder: "Tu contraseña",
			newPassword: "Nueva contraseña",
			newPasswordPlaceholder: "Introduce tu nueva contraseña",
			confirmPassword: "Confirmar contraseña",
			confirmPasswordPlaceholder: "Repite la contraseña",
			forgotPassword: "¿Olvidaste tu contraseña?",
			loginFooter: "¿No tienes una cuenta?",
			registerFooter: "¿Ya tienes una cuenta? Inicia sesión aquí.",
			resendCode1: "¿No recibiste tu código de confirmación? ",
			resendCode2: "Reenviar código de activación",
			sendEmail: "Enviar correo electrónico",
			recoverPassword: "Recuperar contraseña",
			changePassword: "Cambiar contraseña",
			changeEmail: "Cambiar correo electrónico",
			newEmail: "Nuevo correo electrónico",
			newEmailConfirm: "Confirmar nuevo correo electrónico",
			repeatEmail: "Repite el correo electrónico",
			currentEmail: "Correo electrónico actual",
			currentPassword: "Contraseña actual",
			emailSent: "Correo electrónico enviado con éxito",
			repeatPassword: "Repite la contraseña",
			rememberedPassword: "¿Recordaste tu contraseña?",
			adminPassword: "Contraseña de administrador",
			notLoggedIn: "Necesitas estar autenticado para acceder a esta página",
			noMatchPassword: "Las contraseñas no coinciden",
			acceptSubtitle: "Por favor pone una contraseña para confirmar tu cuenta.",
			goBackToLogin: "Ir a la pantalla de inicio de sesión",
			newAccount: "Nueva cuenta",
			registeredSuccessfully:
				"Cuenta registrada con éxito. Por favor revisa tu buzón de correo electrónico para confirmar tu cuenta.",
			passwordChanged: "Contraseña cambiada con éxito.",
			accountConfirmed: "Cuenta confirmada con éxito.",
			typeCredentials: "Introduce tu correo electrónico y contraseña para iniciar sesión.",
			loginConfirmAccount: "¿Aún no tienes una cuenta?",
			loginConfirmAccount2: "Confirma tu cuenta",
			insertEmail: "introduce tu correo electrónico para confirmar tu cuenta.",
			definePassword: "Configurar la contraseña",
			definePassword2: "Configura tu contraseña de acceso.",
			acceptTerms: "Al confirmar la cuenta, acepta los",
			acceptTerms2: "y el",
			acceptEmailContent: "Acepto recibir contenido por correo electrónico",
			acceptance: "Debes aceptar los términos y condiciones para confirmar tu cuenta.",
			recover: "Recuperar",
			insertEmailPassword: "Introduce tu correo electrónico para recuperar tu contraseña",
			actualPassword: "Contraseña actual",
			passwordinfo:
				"La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una letra minúscula, un número y un carácter especial.",
			passwordExpired: "Tu contraseña ha expirado. Por favor, establece una nueva contraseña para continuar.",
			changeExpiredPassword: "Cambiar Contraseña Expirada",
			passwordChangedSuccess: "Contraseña cambiada con éxito. Por favor, inicia sesión de nuevo."
		},

		notFound: {
			header: "Página Perdida"
		},

		errors: {
			invalidArgs: "Argumentos no válidos o ausentes",
			invalidFields: "Campos no válidos o ausentes",
			emailIsInvalid: "El formato de correo electrónico introducido no es válido.",
			fillEmail: "Por favor, escribe un correo electrónico.",
			fillPassword: "Por favor, escribe una contraseña.",
			pleaseFillFormCorrectly: "Por favor, completa el formulario correctamente.",
			fillField: "Este campo es obligatorio",
			notSupportedFile: "Tipo de archivo no soportado",
			nameIsEmpty: "El campo nombre debe completarse",
			passwordsDontMatch: "Los campos 'Nueva contraseña' y 'Confirmar contraseña' no coinciden",
			emailIsEmpty: "El campo correo electrónico debe completarse",
			fileTooBigorInvalid: "El tamaño de la imagen es superior a 8 MB o tiene un formato no válido.",
			invalidFormat: "Formato no válido"
		},

		profile: {
			header: "Perfil",
			generalInfo: "Información General",
			phone: "Teléfono",
			removePicture: "ELiminar imagen",
			saved: "Perfil guardado con éxito.",
			addPhoto: "Añadir foto",
			editPhoto: "Editar Foto",
			myAccount: "Mi cuenta",
			changeEmail: "Cambiar correo electrónico",
			changePassword: "Cambiar contraseña",
			actualEmail: "Correo electrónico actual",
			newEmail: "Nuevo correo electrónico",
			newPassword: "Nueva contraseña",
			emailChange: "El correo electrónico ha sido cambiado con éxito.",
			emailSent: "Se envió un correo electrónico para confirmar el cambio de correo electrónico.",
			emailEmpty: "El campo nuevo correo electrónico está vacío.",
			passwordEmpty: "Debes introducir tu contraseña para cambiar tu correo electrónico.",
			emailSameAsCurrent: "El nuevo correo electrónico debe ser diferente del actual.",
			emailDuplicate: "Este correo electrónico ya está asociado a otra cuenta.",
			emailCodeInvalid: "El enlace de confirmación no es válido o ha caducado. Por favor, solicita un nuevo cambio de correo electrónico.",
			pendingEmailChange: "Cambio pendiente a {0}",
			pendingEmailChangeNote:
				"Confirma el cambio a través del enlace que enviamos a ese correo electrónico. Hasta entonces, tu correo electrónico actual sigue activo.",
			review: "Evaluación",
			reviews: "Evaluaciones",
			psychologist: "Psicólogo",
			noAbout: "Aún no hay información sobre ti.",
			competencies: "Competencias",
			noSkills: "Aún no has definido tus competencias.",
			noReviews: "Aún no hay reseñas.",
			noLanguage: "No se ha definido ningún idioma preferente",
			noLanguages: "Aún no has definido tus idiomas.",
			contactSent: "Tu mensaje ha sido enviado con éxito.",
			receiveEmailNotifications: "Recibir correos electrónicos",
			receiveNotifications: "Recibir notificaciones",
			language: "Idioma",
			languages: "Idiomas",
			languageNote:
				"El idioma sólo se utilizará para reservar citas, de modo que podamos encontrar psicólogos adecuados a tu idioma."
		},

		home: {
			nextAppointment: "Siguiente Consulta",
			nextAppointments: "Siguientes Consultas",
			noAppointments: "Aún no hay consultas reservadas",
			noAppointmentsReport: "Sin informes pendientes",
			scheduledAppointments: "Consultas Futuras",
			needChat: "¿Necesitas hablar con uno de nuestros psicólogos?",
			startChat: "Iniciar chat",
			scheduleAppointment: "Reserva una videoconsulta de psicología",
			scheduleVideoAppointment: "Reservar Videoconsulta",
			psychologicalAppointment: "Consulta de Psicologia",
			psychologicalSupportRequest: "Solicitud de <b>Apoyo Psicológico</b>",
			eapSupportRequest: "Solicitud de <b>Apoyo EAP</b>",
			pendingChats: "Chats pendientes",
			dailyAppointments: "Consultas de hoy",
			noChats: "Sin chat pendiente.",
			noDailyAppointments: "Sin consultas para el día seleccionado.",
			pendingCalls: "Llamadas pendientes",
			noCalls: "Sin llamadas pendientes.",
			videoCalls: "Consulta Remota",
			callsNotAnswered: "Llamadas perdidas",
			noCallsNotAnswered: "No hay llamadas perdidas.",
			cantAcceptCall: "No es posible aceptar una llamada de audio durante una consulta de vídeo o audio.",
			noPatientOnCall: "El paciente no está en la llamada.",
			newCall: "Una nueva llamada de",
			newCall2: "Llamada en espera de contestación.",
			newChat: "Um nuevo chat de",
			newChat2: "Chat pendiente de aceptación.",
			treatmentRating: "Evaluación del tratamiento",
			questionsNotAnswered:
				"Para enviar la evaluación, debe contestar todas las preguntas con excepción de las notas adicionales.",
			reviewSent: "Evalución enviada con éxito.",
			skip: "Pasar",
			typeNote: "Añade una nota...",
			question1: "En general, ¿estás satisfecho con el servicio prestado?",
			question2: "¿En qué medida te gustó el psicólogo que te acompañó?",
			question3: "¿Fue siempre puntual el psicólogo?",
			question4: "¿Te sientes mejor después de la intervención psicológica?",
			question5: "En tu opinión, ¿fue adecuado el número de consultas?",
			question6: "¿Volverías a utilizar el servicio si fuera necesario?",
			question7: "¿En qué medida recomendaría este servicio a un compañero?",
			question8: "¿Crees que esta intervención te ha ayudado a sentirte más motivado?",
			question9: "¿Consideras importante mantener el servicio de apoyo psicológico en tu empresa?",
			notes: "Si tienes alguna sugerencia, escríbela a continuación.",
			reviewHelp:
				'De {0} a {1}, donde {2} es "{3}" y {4} corresponde a "{5}", evalúa las siguientes afirmaciones sobre las videoconsultas de Psicología realizadas con psicólogos del TEAM 24.',
			notReally: "muy poco",
			little: "poco",
			few: "moderadamente",
			many: "mucho",
			alot: "extremadamente"
		},

		events: {
			live: "En directo",
			startsIn: "Empieza en",
			daysLeft: "faltan {n} días",
			dayLeft: "falta 1 día",
			enter: "Entrar",
			showProgram: "Ver programa",
			hideProgram: "Ocultar programa",
			today: "Hoy",
			tomorrow: "Mañana"
		},

		appointments: {
            date: "Data",
            hour: "Hora",
			header: "Consultas",
			single: "Consulta",
			history: "Historial",
			cancel: "Cancelar",
			confirm: "Confirmar",
			reschedule: "Reprogramar",
			schedule: "Reservar Consulta",
			noAppointments: "Aún no hay consultas reservadas",
			noAppointmentsReport: "Sin informes pendientes",
			selectDate: "Seleccione el día",
			selectMonth: "Selecione el mes",
			availableSlots: "Horarios disponibles",
			cancelAppointment: "¿Estás seguro de que quieres cancelar la consulta?",
			replyMessage: "Escribe algo aquí...",
			noSlots: "No hay horarios disponibles para el día seleccionado.",
			type: "Consulta de Psicología",
			noHistory: "No existen consultas efectuadas en el periodo seleccionado.",
			created: "La consulta fue reservada con éxito.",
			rescheduled: "La consulta fue reprogramada con éxito.",
			cancelled: "La consulta fue cancelada con éxito.",
			checkPatient: "Ver Paciente",
			pendingReport: "Consultas sin Informe",
			report: "Informe Clinico",
			noMoreAppointments: "No hay futuras consultas reservadas.",
			nextConsultations: "Siguientes Consultas",
			noConsultations: "No existen más consultas reservadas.",
			editAppointment: "Editar Consulta",
			edited: "Consulta editada con éxito.",
			client: "Cliente",
			duration: "Duración",
			lunchBreak: "Pausa para almorzar",
			createReport: "Crear informe clínico",
			startCall: "Iniciar videollamada",
			selectPsychologist: "Selecciona un psicólogo",
			scheduleOptions: "Deseja Marcar",
            scheduleType: "Tipo de Marcação",
            optionOther: "Outro",
            optionConsultation: "Consulta",
            selectPatient: "Selecciona un Paciente",
            motive: "Motivo",
			availabilityLegend: "Disponibilidad"
		},

		chat: {
			header: "Chat",
			startChat: "Iniciar chat",
			confirmStartChat: "¿Estás seguro de que quieres iniciar el chat?",
			endChat: "¿Quieres terminar el chat?",
			howDidItGo: "¿Cómo evalúas el apoyo prestado por nuestro psicólogo?",
			noMatchingCriteria: "No hay pacientes según la búsqueda realizada.",
			empty: "Aún no hay pacientes asociados",
			noChats: "Aún no hay chats disponibles.",
			closedChat: "Este chat está cerrado y ya no es posible contestarlo.",
			closedChatFormat1: "Este chat está cerrado. Haz clic",
			outOfOpeningHours: "Gracias por contactar con TEAM 24, un psicólogo responderá a tu chat en breve.",
			here: "aquí",
			closedChatFormat2: "para abrirlo de nuevo.",
			selectRating: "Evalúa la llamada antes de continuar.",
			sentReview: "Gracias por enviar tu evaluación.",
			chatOpen: "Ya existe una conversación pendiente o abierta.",
			selectChat: "Selecciona un chat o inicia uno nuevo.",
			selectChatPsych: "Por favor, selecciona un chat",
			confirmDeleteMessage: "¿Estás seguro de que quieres eliminar el mensaje?"
		},

		coworkers: {
			number: "N.º Trabajador. (0-9)",
			status: "Estado",
			add: "Añadir Trabajador",
			edit: "Editar Trabajador",
			upload: "Importar Trabajadores",
			uploadDisable: "Desativar Trabajadores",
			download: "Descargar plantilla",
			import: "Importar",
			imported: "Los trabajadores han sido importados con éxito.",
			importedWithErrors:
				"Trabajadores importados con éxito. Algunos trabajadores no se importaron (ver lista de errores).",
			importedErrors: "Trabajadores no Importados (Errores)",
			roleUser: "Trabajadores",
			roleHr: "Recursos Humanos",
			added: "El trabajador ha sido añadido con éxito.",
			edited: "El trabajador ha sido editado con éxito.",
			deleted: "El trabajador ha sido eliminado con éxito.",
			role: "Puesto",
			business: "Empresa",
			group: "Grupo",
			resendInvite: "Reenviar Confirmación de Cuenta",
			areYouSure: "¿Quieres reenviar la confirmación de cuenta a todos los trabajadores pendientes?",
			innactiveUsers: "Ver Inactivos",
			resendBusinessEmailSuccess: "Los correos electrónicos serán enviados en los próximos minutos."
		},

		dashboard: {
			contract: "Contrato",
			sosButton: "Botón de llamada",
			chatButton: "Botón de Chat",
			usage: "Usuarios",
			videoAppointments: "Videoconsultas de Psicología",
			hotline: "Línea de Apoyo Psicológico",
			disturbances: "Problemas identificados",
			contractDetails: "Detalles Contractuales",
			purchased: "Adquirido",
			consumed: "Consumido",
			balance: "Saldo",
			scheduled: "Consultas Reservadas",
			finished: "Consultas Efectuadas",
			details: "Ver Detalle",
			clicked: "N.º de clics",
			newUsers: "Nuevos Usuarios",
			usageApp: "Uso de la aplicación",
			noData: "No hay fecha registrada para el periodo seleccionado.",
			calls: "Línea de Apoyo Psicológico",
			chats: "Chat de Apoyo Psicológico",
			exportPdf: "Exportar informe en PDF",
			exportRateLimited: "Ya se han generado demasiados informes; inténtelo de nuevo dentro de unos minutos."
		},

		contactUs: {
			haveQuestions: "¿Tienes dudas?",
			sendUsMessage: "Puedes enviarnos un mensaje con tus preguntas y te responderemos lo más pronto posible.",
			subject: "Asunto",
			description: "Descripción",
			send: "Enviar"
		},

		eap: {
			legal: 'Soporte <br/><span class="eap-highlight"><b>Legal</b></span>',
			tax: 'Soporte <br/><span class="eap-highlight"><b>Fiscal</b></span>',
			finantial: 'Apoyo <br/><span class="eap-highlight"><b>financiero</b></span>',
			social: 'Apoyo <br/><span class="eap-highlight"><b>social</b></span>',
			nutritional: 'Apoyo <br/><span class="eap-highlight"><b>nutricional</b></span>',
			healthInsurance: 'Seguro de <br/><span class="eap-highlight"><b>salud</b></span>',
			text: "Envíanos tu solicitud y te responderemos lo antes posible.",
			requests: "Pedidos",
			nif: "Inserte su número de identificación fiscal aquí..."
		},

		patients: {
			patient: "Paciente",
			clinicalRecord: "Registro clinico",
			otherName: "Nombre por el que desea ser llamado",
			birthdate: "Fecha de nacimiento",
			treatments: "Tratamientos",
			treatment: "Tratamiento",
			diagnostics: "Problemáticas Identificadas",
			clinicalDischarge: "Alta Clínica",
			takeMeds: "¿Toma medicación?",
			meds: "Medicación",
			objective: "Objetivos del Tratamiento",
			details: "Ver detalles",
			noTreatments: "No hay tratamientos registrados para este paciente.",
			saved: "El paciente fue editado con éxito."
		},

		reports: {
			header: "Informe Clínico",
			anamnese: "Anamnesis Clínica",
			report: "Registro Clínico",
			intervention: "Intervención Clínica",
			objectivesNextAppointment: "Objetivos de la próxima consulta",
			date: "Fecha y hora de la consulta",
			schedule: "Reservar la próxima consulta",
			save: "Grabar Informe Clínico",
			saved: "Informe clínico grabado con éxito.",
			reportClosed: "El informe sobre esta consulta ya está concluido.",
			invalidDiagnostics: "El campo diagnóstico es obligatorio.",
			invalidGoals: "El campo objetivos del tratamiento es obligatorio",
			invalidAnamnesis: "El campo anamnesis clínica es obligatorio"
		},

		placeholders: {
			name: "Tu nombre",
			email: "el_suyo@email.com",
			phoneNumber: "+351265000000 (0-9)",
			language: "Selecciona un idioma",
			role: "Selecciona una posición",
			currentPassword: "Contraseña actual",
			newPassword: "Nueva contraseña",
			confirmPassword: "Confirmar nueva contraseña",
			newEmail: "nuevo@email.com",
			page: "página",
			titlePage: "Título de la Página",
			link: "https://www.google.com/",
			profilePic: "Imagen de Perfil",
			password: "Tu contraseña",
			description: "Escribe tu pregunta...",
			selectSkills: "Selecciona tus competencias",
			selectLanguages: "Selecciona tus idiomas",
			patients: "Busca paciente..."
		},

		serverErrors: {
			title: "Error del Servidor",
			subTitle: "¡No eres tú, somos nosotros!",
			refresh: "Volver a la página anterior",
			backToHome: "Ir al inicio",
			accountNotConfirmed: "Cuenta no confirmada.",
			notFound: "Cuenta no existente.",
			invalidCredentials: "La cuenta no existe o las credenciales no son válidas.",
			tooManyRequests: "Demasiados intentos. Por favor, inténtalo de nuevo más tarde.",
			requestNotPossible: "No ha sido posible contactar con el servidor. Por favor, inténtalo de nuevo más tarde."
		},

		footer: {
			downloadOn: "Descargar en",
			appStore: "App Store",
			getIt: "Consíguelo en",
			googlePlay: "Google Play"
		},

		ranges: {
			today: "Hoy",
			thisMonth: "Este mes",
			lastMonth: "Mes anterior",
			thisYear: "Este año",
			lastYear: "El año pasado"
		},

		video: {
			fullscreen: "Pantalla completa",
			exitFullscreen: "Salir de pantalla completa",
			minimize: "Minimizar ventana",
			maximize: "Restaurar ventana",
			mute: "Desactivar micrófono",
			unmute: "Activar micrófono",
			disableVideo: "Desactivar vídeo",
			enableVideo: "Activar vídeo",
			disconnect: "Finalizar videollamada"
		},

		dnd: {
			title: "No molestar",
			oneHour: "1 hora",
			twoHours: "2 horas",
			untilEndOfDay: "Hasta el final del día",
			turnOff: "Desactivar",
			activeUntil: "Silenciado hasta las {0}",
			tooltip: "Las llamadas SOS y las solicitudes de chat siguen apareciendo en Inicio, solo que sin sonido ni avisos.",
			missedSummary: "Recibiste {0} llamadas SOS y {1} solicitudes de chat mientras estabas en No molestar.",
			goToHome: "Ir a Inicio",
			tooltipInactive: "Silenciar el tono de las llamadas SOS y de los chats durante un período",
			chooseDuration: "Silenciar notificaciones durante:",
			activatedFeedback: "No molestar activo hasta las {0}. Las llamadas SOS y los chats siguen apareciendo en Inicio.",
			deactivatedFeedback: "No molestar desactivado"
		}
	}
});
